import UnknownFileFormat from "@/assets/unknow-format.png";
import FileImage from "@/assets/file.png";
import { EVENT_TYPES_DETAILS, LOCAL_TIMEZONE } from "./types/constants";
import { EventObj } from "./types/interfaces";
import { differenceInDays, format, parse, parseISO } from "date-fns";

export const getDocumentPreview = (value: string) => {
  let fileType = value.split(".").pop();

  if (fileType?.includes("?")) {
    fileType = fileType?.split("?")[0];
  }

  fileType = fileType?.trim();

  if (!fileType) {
    return UnknownFileFormat;
  } else {
    if (["jpeg", "jpg", "png"].includes(fileType)) {
      return value;
    } else if (
      [
        // Documents
        "pdf",
        "doc",
        "docx",
        "xls",
        "xlsx",
        "csv",

        // Text
        "txt",
      ].includes(fileType)
    ) {
      return FileImage;
    } else {
      return UnknownFileFormat;
    }
  }
};

export const getLocalTimezone = () => {
  return LOCAL_TIMEZONE;
  // return Intl.DateTimeFormat().resolvedOptions().timeZone === "Asia/Calcutta"
  //   ? "Asia/Kolkata"
  //   : Intl.DateTimeFormat().resolvedOptions().timeZone;
};

const keysToSkip = ["type", "subType"];

export const convertType = (currentEvent: EventObj, toType: string) => {
  const defaultValue = (EVENT_TYPES_DETAILS as any)[toType].getDefaultValue();

  const newObj = {
    ...defaultValue,
  };

  Object.keys(newObj).forEach((key) => {
    if (!keysToSkip.includes(key) && key in currentEvent) {
      newObj[key] = (currentEvent as any)[key];
    }
  });

  return newObj;
};

export const findDateDifferenceInDays = (date2: string, date1: string) => {
  const parsedDate2 = parseISO(date2);
  const parseDate1 = parseISO(date1);
  return differenceInDays(parsedDate2, parseDate1);
};

export const parseDate = (date: string) => {
  return parse(date, "yyyy-MM-dd", new Date());
};

export const formatDate = (date: Date) => {
  return format(date, "yyyy-MM-dd");
};
